import React from 'react';

const AutoMatsLogo = ({ className = "", variant = "primary", size = "default" }) => {
  const sizeClasses = {
    small: "h-24",
    default: "h-96",  // Twice as big as previous size for better visibility
    large: "h-128"
  };

  // Use the new clean AutoMats logo image (logo only, no text)
  const logoUrl = "/images/automats-logo.webp";

  // For both icon and primary variants, just show the logo image at proper size
  return (
    <div className={`inline-flex items-center ${className}`}>
      <img 
        src={logoUrl} 
        alt="AutoMats Logo" 
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default AutoMatsLogo;